function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { ensureClientInitialized, kernelsClient } from "@kaggle/sdk";
import { getErrorReporter } from "../../common/ErrorReporter/errorReporter";
var FIREBASE_APP_NAME = "Kernels";
var firestoreClient;
var firestoreClientLoaded = false;
export var isFirestoreClientLoaded = function() {
    return firestoreClientLoaded;
};
function fetchFirebaseConfig() {
    return _fetchFirebaseConfig.apply(this, arguments);
}
function _fetchFirebaseConfig() {
    _fetchFirebaseConfig = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var firebaseConfig, authToken;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return kernelsClient.kernelsService.getFirebaseConfig({});
                case 2:
                    firebaseConfig = _ctx.sent;
                    _ctx.next = 5;
                    return kernelsClient.kernelsService.getFirebaseAuthToken({});
                case 5:
                    authToken = _ctx.sent.authToken;
                    return _ctx.abrupt("return", {
                        authToken: authToken,
                        options: firebaseConfig,
                        proxyDomain: firebaseConfig.proxyDomain
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchFirebaseConfig.apply(this, arguments);
}
export function getKernelsFirestoreClient(createFirestoreClient, onError) {
    return _getKernelsFirestoreClient.apply(this, arguments);
}
function _getKernelsFirestoreClient() {
    _getKernelsFirestoreClient = _asyncToGenerator(regeneratorRuntime.mark(function _callee(createFirestoreClient, onError) {
        var defaultErrorHandler;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    defaultErrorHandler = function(errorMsg) {
                        var ref;
                        (ref = getErrorReporter()) === null || ref === void 0 ? void 0 : ref.report(new Error(errorMsg));
                    };
                    if (!firestoreClient) {
                        firestoreClient = fetchFirebaseConfig().then(function(config) {
                            return ensureClientInitialized(FIREBASE_APP_NAME, config, /* onFirebaseConnectionError= */ onError !== null && onError !== void 0 ? onError : defaultErrorHandler);
                        }).then(function(cli) {
                            return createFirestoreClient(cli);
                        });
                        firestoreClient.then(function(cli) {
                            return firestoreClientLoaded = !!cli;
                        });
                    }
                    return _ctx.abrupt("return", firestoreClient);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getKernelsFirestoreClient.apply(this, arguments);
}
